/**
 * Datos globales de MANGIBONE (datos estáticos de la maqueta).
 *
 * La nav y las redes sociales vienen de `schemas/definitions/navigation-schema.json`
 * (seo-ctrl las lee para inyectar og:title/og:description y el header/footer las
 * consume vía el set de íconos MANGIBONE + `Icons`).
 */
export interface CategoryCard {
  title: string;
  image: string;
  copy: string;
  /** URL asignada a la que navega la tarjeta (fallback estático). */
  link?: string;
}

export const site = {
  brand: {
    name: "MANGIBONE",
    logo: "/assets/design/logo.png",
    logoLosPinos: "/assets/brand/los-pinos.png",
    slogan: "Come rico, come sabroso, come bien.",
  },
  // Inicio (Figma 110:400): foto del hero y tienda circular de la bienvenida.
  heroImage: "/assets/hero/counter.jpg",
  welcomeImage: "/assets/design/ellipse-19.webp",
  // Tarjetas de categoría de "Nuestros productos" (Figma Inicio 186:36/211/212).
  categories: [
    {
      title: "Edición especial",
      image: "/assets/design/prod-inicio-4.webp",
      copy: "Los mejores lácteos para que disfrutes productos frescos, llenos de sabor y elaborados con dedicación. Prueba la variedad de productos lácteos que tenemos para ti",
      link: "/productos?categoria=edicion-especial",
    },
    {
      title: "Lácteos",
      image: "/assets/design/prod-inicio-3.webp",
      copy: "Disfruta nuestra selección de quesos frescos y artesanales, elaborados con leche de calidad y sabor auténtico.",
      link: "/productos?categoria=lacteos",
    },
    {
      title: "Cárnicos",
      image: "/assets/design/rect-35.webp",
      copy: "Disfruta nuestra selección de quesos frescos y artesanales, elaborados con leche de calidad y sabor auténtico.",
      link: "/productos?categoria=carnicos",
    },
  ] as CategoryCard[],
  contact: {
    email: "ventas@mangibone.com",
    phone: "+52 775 100 3218",
    whatsapp: "https://wa.me/527751003218",
    address: "C. 3ra Cerrada del Tezontle, No. 21, Fracc. Vista Real, C.P. 43700, Tulancingo de Bravo, Hidalgo",
  },
};

export default site;
